/* index.tsx generated by @compiled/babel-plugin v2.0.0 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbismd%7Bdisplay%3Avar(--expandable-chevron-display)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%5Bdir%3Drtl%5D%20._4lYzgRyz1h%7Btransform%3AscaleX(-1)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbC5M9%7Bdisplay%3Avar(--expandable-provided-elembefore-display)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1UtDYzrFwf%7Bcolor%3Avar(--ds-icon-selected%2C%231868db)%7D");
import React, { type ReactNode } from 'react';
import ChevronDownIcon from '@atlaskit/icon/core/chevron-down';
import ChevronRightIcon from '@atlaskit/icon/core/chevron-right';
import type { IconProps } from '@atlaskit/icon/types';
import { chevronDisplayCssVar, providedElemBeforeDisplayCssVar } from '../../../../common/constants';
type ExpandableMenuItemIconProps = {
  isExpanded: boolean;
  isHovering: boolean;
  isSelected?: boolean;
  /**
   * The element to display when the user is not hovering over the icon. If not provided, the chevron icon will be used
   */
  providedElemBefore?: ReactNode;
  iconProps?: IconProps;
};
const iconStyles = {
  chevron: "_3iDTPbismd _4lYzgRyz1h",
  providedElemBefore: "_3iDTPbC5M9",
  providedElemBeforeSelected: "_1UtDYzrFwf"
};
export const ExpandableMenuItemIcon = ({
  iconProps,
  isExpanded,
  isSelected,
  providedElemBefore
}: Omit<ExpandableMenuItemIconProps, 'isHovering'>): JSX.Element => {
  const ChevronIcon = isExpanded ? ChevronDownIcon : ChevronRightIcon;
  const chevronElem = <ChevronIcon {...iconProps} label="" color={isSelected ? "var(--ds-icon-selected, #1868DB)" : undefined} size="small" />;
  return <React.Fragment>
			<div className={ax([iconStyles.chevron])}>{chevronElem}</div>
			{/* If there is no provided elemBefore, not rendering the wrapper either to simplify the DOM */}
			{providedElemBefore && <div className={ax([iconStyles.providedElemBefore, isSelected && iconStyles.providedElemBeforeSelected])}>
					{providedElemBefore}
				</div>}
		</React.Fragment>;
};